import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMap from "highcharts/modules/map";
import HighchartsBoost from "highcharts/modules/boost";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";

const MapChart = ({ options, hasData }) => {
    highchartsMap(Highcharts);
    HighchartsBoost(Highcharts);
    NoDataToDisplay(Highcharts);

    return (
        <div id="chart-component" style={{ position: "relative", minHeight: "400px" }}>
            {!hasData && (
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#606060",
                        fontWeight: "bold",
                        fontSize: "12px",
                        zIndex: 10,
                        pointerEvents: "none",
                    }}
                >
                    No hay datos para mostrar
                </div>
            )}
            <HighchartsReact constructorType="mapChart" highcharts={Highcharts} options={options} />
        </div>
    );
};

export default MapChart;
